import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditCompanyMappingPage = withSuspense(lazy(() => import('./edit-deal')));
export default EditCompanyMappingPage;
